import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { locationsScheme } from "../../../lib/validations/locationsValidation";
import {
  createAndUpdateLocationsServer,
  getLocationsServer,
} from "../../../apis/locationsApi";
import { getCategoriesServer } from "../../../apis/categoriesApi";
import TextInputFormik from "../../../lib/common/TextInputFormik";

export default function AddLocations() {
  const [loading, setLoading] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  const [categories, setCategories] = useState([]);
  const [addLocationsInitial, setAddLocationsInitial] = useState({
    name: "",
    address: "",
    lat: "",
    long: "",
    type: "",
    count: "",
    attributes: "",
    categoryId: "",
  });
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      editLocations(id);
    }
    getcategories();
  }, [id]);

  const editLocations = async (id) => {
    // setEditLoader(true)
    try {
      const res = await getLocationsServer(id);
      if (res.result) {
        setAddLocationsInitial({
          name: res.result.name,
          address: res.result.address,
          lat: res.result.lat,
          long: res.result.long,
          type: res.result.type,
          count: res.result.count,
          attributes: res.result.attributes,
          categoryId: res.result.catId,
        });
      }
    } catch (error) {
      console.error("Error fetching Locations:", error);
    } finally {
      setLoading(false);
    }
  };
  const getcategories = async () => {
    try {
      const res = await getCategoriesServer();
      if (res?.result) {
        setCategories(res.result);
      }
    } catch (err) {
      console.error("Failed to fetch categories:", err);
    }
  };
  const formik = useFormik({
    initialValues: addLocationsInitial,
    enableReinitialize: true,
    validationSchema: locationsScheme,
    onSubmit: async (values) => {
      console.log(values);
      try {
        setLoading(true);
        // console.log(values)
        let res;
        if (id) {
          res = await createAndUpdateLocationsServer(id, values);
          console.log(res);
        } else {
          res = await createAndUpdateLocationsServer(null, values);
        }
        setLoading(false);
        formik.resetForm();
        navigate("/locations");
      } catch (error) {
        console.error("Error submitting form:", error);
        throw error;
      }
    },
  });
  const backClick = () => {
    navigate("/locations");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            {" "}
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              {editLoader ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit} className="formMaxwidth">
                  {/* Name */}
                  <TextInputFormik label="Name" field="name" formik={formik} />

                  {/* Address */}
                  <TextInputFormik
                    label="Address"
                    field="address"
                    formik={formik}
                  />

                  {/* Latitude */}
                  <TextInputFormik
                    label="Latitude"
                    field="lat"
                    formik={formik}
                  />

                  {/* Longitude */}
                  <TextInputFormik
                    label="Longitude"
                    field="long"
                    formik={formik}
                  />

                  {/* Type */}
                  <TextInputFormik label="Type" field="type" formik={formik} />

                  {/* Count */}
                  <TextInputFormik
                    type="number"
                    label="Count"
                    field="count"
                    formik={formik}
                  />

                  <TextInputFormik
                    label="Attributes"
                    field="attributes"
                    formik={formik}
                  />

                  {/* Category */}
                  <div className="input-block mb-3">
                    <label className="col-form-label">
                      Category <span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-control"
                      name="categoryId"
                      value={formik.values.categoryId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <option value="">Select Category</option>
                      {categories.map((cat) => (
                        <option key={cat.id} value={cat.id}>
                          {cat.name}
                        </option>
                      ))}
                    </select>
                    {formik.errors.categoryId && formik.touched.categoryId && (
                      <span className="text-danger">
                        {formik.errors.categoryId}
                      </span>
                    )}
                  </div>

                  {/* Submit button or loading spinner */}
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <button className="btn btn-primary" type="submit">
                      {id ? "Update" : "Submit"}
                    </button>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
